export default "__VITE_ASSET__245910cb__"